import { gql } from '@apollo/client';

export const CREATE = gql`
  mutation CreateAdmin($input: CreateAdminInput!) {
    createAdmin(input: $input) {
      _id
    }
  }
`;

export const UPDATE = gql`
  mutation UpdateAdmin($input: UpdateAdminInput!) {
    updateAdmin(input: $input) {
      _id
    }
  }
`;

export const DISABLE = gql`
  mutation DisableAdmin($id: ObjectId!) {
    disableAdmin(_id: $id) {
      _id
    }
  }
`;
